<template lang="pug">
  .w-100.mh-100.h-100
    .d-flex#axis-title(v-if="!reportData.IsSummary && hasPoints")
      div(v-for="item in chartAxis", :key="item.name")
        b-form-checkbox.mr-2(v-model="item.selected", value="true", :style="{ color: item.color}") {{ item.text }}
      b-button.p-0(style="margin-left: auto;" variant="light", title="Перейти в сообщения по клику в графике", @click="messageActive = !messageActive")
        b-icon(:icon="messageActive ? 'envelope-fill' : 'envelope'", variant="dark")
    .d-flex(v-if="!reportData.IsSummary")
      .track_server-chart.row.no-gutters.w-100(v-if="hasPoints")
        .track_chart.col(ref="chart-wrapper")
          D3#reportingSVGd3(v-if="widthSize" ref="d3", :params="paramsChart", :key="keySVG")
    div(v-if="reportSummary.Totals.length > 0")
      .h6 Сводка
      dx-data-grid(ref="grid"
      :data-source='reportSummary.Totals'
      :selection="{ mode: 'single' }"
      :show-borders='true'
      :style="{ 'max-height': '300px', width: localWidth }"
      :columns="!reportData.IsSummary ? fieldsTotals.filter(f => f.dataField !== 'ObjectName') : fieldsTotals"
      :row-alternation-enabled="true"
      :allow-column-dragging="false"
      :summary="summary"
      @content-ready="onContentReady")
        dx-scrolling(mode='virtual', :useNative="false")
        dx-load-panel(:enabled="true")
        dx-grouping(:auto-expand-all="reportData.IsSummary")
</template>
<script>
import { DxDataGrid, DxScrolling, DxPaging, DxHeaderFilter, DxSorting, DxLoadPanel, DxGrouping } from 'devextreme-vue/data-grid';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import dataGridReports from '@/mixins/dataGridReports';
import sizeProps from '@/mixins/sizeProps';
import D3 from '~/components/VueD3';

const chartColors = ['#24a221', '#d8241f', '#9564bf', '#8d5649', '#1776b6', '#ff7f00', '#e574c3', '#7f7f7f', '#bcbf00', '#00bed1', '#1b9e77', '#d95f02', '#7570b3', '#e7298a', '#66a61e', '#e6ab02', '#a6761d', '#666666'];

export default {
  name: 'FuelMultiple',
  components: {
    D3,
    DxDataGrid,
    DxScrolling,
    DxPaging,
    DxHeaderFilter,
    DxSorting,
    DxLoadPanel,
    DxGrouping,
  },
  mixins: [dataGridReports, sizeProps],
  props: {
    reportData: {
      type: Object,
      default () {
        return {};
      },
    },
    track: {
      type: Object,
      default () {
        return {};
      },
    },
    colors: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  data () {
    return {
      fieldsTotals: [{
        dataField: 'ObjectName',
        caption: 'Объект',
        groupIndex: 0,
      }, {
        dataField: 'FuelSensorName',
        caption: 'Датчик',
        groupIndex: 1,
      }, {
        dataField: 'Date',
        caption: 'Дата',
        alignment: 'right',
        width: 180,
        customizeText: params => new Date(params.value * 1000).toLocaleDateString('ru', { timeZone: 'UTC' }),
      }, {
        dataField: 'FuelSensorSum',
        caption: 'Потрачено по ДУТ, л',
        alignment: 'right',
      }, {
        dataField: 'BeginFuelLevel',
        caption: 'Начальный уровень топлива, л',
        alignment: 'right',
      }, {
        dataField: 'EndFuelLevel',
        caption: 'Конечный уровень топлива, л',
        alignment: 'right',
      }, {
        dataField: 'FillSum',
        caption: 'Заправлено, л',
        alignment: 'right',
      }, {
        dataField: 'FillCount',
        caption: 'Всего заправок',
        alignment: 'right',
      }, {
        dataField: 'DrainSum',
        caption: 'Слито, л',
        alignment: 'right',
      }, {
        dataField: 'DrainCount',
        caption: 'Всего сливов',
        alignment: 'right',
        width: 75,
      }],
      rowsSumTotal: [
        {
          key: 'FuelSensorSum',
          name: 'Потрачено по ДУТ',
          unit: 'л',
          validate: value => true,
        }, {
          key: 'FuelSensorAvg',
          name: 'Ср. расход по ДУТ',
          unit: 'л/100 км',
          validate: value => true,
        }, {
          key: 'FuelImpulseSensor',
          name: 'Потрачено по ДАРТ',
          unit: 'л',
          validate (value) {
            return value !== null && !Number.isNaN(value);
          },
        }, {
          key: 'EngineHoursConsumption',
          name: 'Потрачено по моточасам',
          unit: 'л',
          format: true,
          validate: value => true,
        }, {
          key: 'ParkingEngineHoursConsumption',
          name: 'Потрачено на холостом ходу',
          unit: 'л',
          validate: value => true,
        }, {
          key: 'Consumption',
          name: 'Расход по моточасам',
          unit: ' л/ч',
          validate: value => true,
        }, {
          key: 'FillSum',
          name: 'Всего заправлено',
          unit: 'л',
          validate: value => true,
        }, {
          key: 'FillCount',
          name: 'Всего заправок',
          validate: value => true,
        }, {
          key: 'DrainSum',
          name: 'Всего топлива слито',
          unit: 'л',
          validate: value => true,
        }, {
          key: 'DrainCount',
          name: 'Всего сливов',
          validate: value => true,
        }, {
          key: 'MileageKm',
          name: 'Пробег',
          unit: 'км',
          validate: value => true,
        }, {
          key: 'EngineHoursText',
          name: 'Моточасы всего',
          validate: value => true,
        }, {
          key: 'ParkingEngineHoursText',
          name: 'Моточасы на холостом ходу',
          validate: value => true,
        }, {
          key: 'RideEngineHoursText',
          name: 'Моточасы в движении',
          validate: value => true,
        }, {
          key: 'BeginFuelLevel',
          name: 'Начальное значение топлива',
          unit: 'л',
          validate: value => true,
        }, {
          key: 'EndFuelLevel',
          name: 'Конечное значение топлива',
          unit: 'л',
          validate: value => true,
        },
      ],
      rowClick: null,
      chartAxis: [{
        text: 'Бак 1',
        name: 'FUEL_TANK_1_Fuel',
        color: '#2578B2',
        selected: true,
        groupIndex: 0,
        z: 1,
      }, {
        text: 'Бак 1 (сред.)',
        name: 'FUEL_TANK_1_AVG',
        color: '#32A034',
        selected: true,
        groupIndex: 0,
        z: 2,
      }, {
        text: 'Бак 2',
        name: 'FUEL_TANK_2_Fuel',
        color: '#D4212E',
        selected: true,
        groupIndex: 0,
        z: 3,
      }, {
        text: 'Бак 2 (сред.)',
        name: 'FUEL_TANK_2_AVG',
        color: '#FD7D26',
        selected: true,
        groupIndex: 0,
        z: 4,
      }],
      summary: {
        groupItems: [
          {
            column: 'FuelSensorSum',
            summaryType: 'sum',
            alignByColumn: true,
            displayFormat: '{0}',
          }, {
            column: 'DrainCount',
            summaryType: 'sum',
            alignByColumn: true,
            displayFormat: '{0}',
          }, {
            column: 'DrainSum',
            summaryType: 'sum',
            alignByColumn: true,
            displayFormat: '{0}',
          }, {
            column: 'FillCount',
            summaryType: 'sum',
            alignByColumn: true,
            displayFormat: '{0}',
          }, {
            column: 'FillSum',
            summaryType: 'sum',
            alignByColumn: true,
            displayFormat: '{0}',
          },
        ],
      },
      messageActive: false,
      keySVG: 'svgReporting',
      reportSummary: {
        Totals: [],
      },
      widthSize: null,
    };
  },
  computed: {
    hasPoints () {
      return !this.reportData.IsSummary || this.reportData.Data.Data.Rows.reduce((prev, curr) => prev + curr.PointsCount, 0) > 0;
    },
    paramsChart () {
      if (this.reportData.IsSummary || !this.widthSize) {
        return {};
      }

      return {
        name: 'reportingChartControl',
        series: {
          id: this.reportData.id,
          axis: this.chartAxis,
        },
        loadDataUrl: '/Reporting/ChartPoints',
        getPointInfo: '/Reporting/PointInfo',
        selectRowTrack: this.selectRowReport,
        message: this.messageActive,
        noinfo: this.preparePoints(this.reportData.Data.Data.RideDetectorEvents.filter(x => x.Name === 'нет информации')),
        rides: this.preparePoints(this.reportData.Data.Data.RideDetectorEvents.filter(x => x.Name === 'поездка')),
        width: this.widthSize - 20,
        height: 500,
        svgName: 'reportingSVG',
      };
    },
  },
  watch: {
    reportData (value) {
      this.rowClick = null;
      if (value.IsSummary) {
        this.convertSummaryData(value);
      }
      this.chartAxis.forEach((_c) => {
        const c = _c;
        c.selected = true;
      });
      this.updateSVG();
    },
    widthSize () {
      this.updateSVG();
    },
  },
  created () {
    loadMessages(ruMessages);
    locale('ru');
  },
  mounted () {
    this.convertSummaryData(this.reportData);
    this.updateChartWidth();
  },
  updated () {
    this.updateChartWidth();
  },
  methods: {
    preparePoints (points) {
      return points.map(x => ({ BeginDate: x.Begin * 1000, EndDate: x.End * 1000 }));
    },
    updateChartWidth () {
      if (this.$refs['chart-wrapper']) {
        const t = getComputedStyle(this.$refs['chart-wrapper']).width;
        const res = Math.floor(Number(t.substring(0, t.length - 2)));
        this.widthSize = res < 101 ? 101 : res;
      }
    },
    onSelectionChanged (item) {
      if (item.rowType === 'data') {
        if (this.reportData.BuildTrack && this.track.Id) {
          if (!(this.rowClick && this.rowClick.Begin === item.data.Begin && this.rowClick.End === item.data.End)) {
            const timeZone = Number(this.reportData.TimeZone.split(':', 3)[0]);
            const periods = [[new Date((item.data.Begin - timeZone * 3600) * 1000), new Date((item.data.End - timeZone * 3600) * 1000)]];
            this.$store.dispatch('tracks/updateTrack', { reportId: this.track.Id, secondColor: this.colors.alternative.hex, periods });
            this.reportData.periodsPartTrack = periods;
            this.rowClick = {
              Begin: item.data.Begin,
              End: item.data.End,
            };
          }
        }
        if (item.column.dataField === 'Begin' || item.column.dataField === 'End' || item.column.dataField === 'Location') {
          const value = {
            lat: item.data.LocationLatitude,
            lng: item.data.LocationLongitude,
          };
          this.$store.commit('map/setCenter', value);
          this.$store.commit('tracks/setActivePoint', [value.lat, value.lng]);
        }
      }
    },

    selectRowReport (pointId, timestamp) {
      this.activeSubTab = 0;
      this.activePoint = {
        id: pointId,
        TimeStamp: timestamp,
      };
      this.gridApi.forEachNode((node) => {
        if (this.activePoint.id === node.data.id) {
          node.setSelected(true, true);
          this.gridApi.ensureIndexVisible(node.rowIndex, 'top');
          this.gridApi.setFocusedCell(node.rowIndex, '_checkbox_selector', 'top');
        }
      });
    },
    updateSVG () {
      this.keySVG = this.keySVG === 'svgReporting' ? 'reloadReportingSVG' : 'svgReporting';
    },

    convertSummaryData (data) {
      const rows = [];
      this.chartAxis = [];
      const { chartAxis } = this;

      function addChart (name) {
        const n = chartAxis.length / 2 + 1;
        const tankName = name === 'SUMM' ? 'Все баки' : `Бак ${n}`;
        chartAxis.push({
          text: tankName,
          name: `${name}_Fuel`,
          color: chartColors[chartAxis.length % chartColors.length],
          selected: true,
          groupIndex: 0,
          z: chartAxis.length + 1,
        });
        chartAxis.push({
          text: `${tankName} (сред.)`,
          name: `${name}_AVG`,
          color: chartColors[chartAxis.length % chartColors.length],
          selected: true,
          groupIndex: 0,
          z: chartAxis.length + 1,
        });
        return tankName;
      }

      function parseData (innerData, objectName) {
        innerData.Rows.forEach((_row, i) => {
          const name = addChart(_row.FuelSensorName);
          _row.Rows.forEach((item, j) => {
            rows.push({
              ...item,
              FuelSensorName: name,
              ObjectName: objectName || innerData.ObjectName,
              Group: i,
              RowNum: j + 1,
            });
          });
        });
      }

      if (data.IsSummary) {
        data.Data.Data.forEach(parseData);
      } else {
        parseData(data.Data.Data);
      }
      addChart('SUMM');
      this.reportSummary.Totals = rows;
    },
  },
};
</script>
<style lang="stylus" scoped>
  .track_server-chart {
    display: flex;
    height: 100%;
  }
</style>
